export default "__VITE_ASSET__a16e611e__"